module.exports = __webpack_public_path__ + "img/circle-text.bbf2318b.svg";